import React from 'react';
import { useScrollViewTabsContext } from '@/contexts/scroll-view-tabs-context';
import { View, ViewProps } from 'react-native';

type Props = ViewProps & {
  title: string;
};

export const ItemDetailTabSection: React.FC<Props> = ({
  onLayout,
  title,
  ...rest
}) => {
  const { registerTab } = useScrollViewTabsContext();
  return (
    <View
      onLayout={(e) => {
        onLayout?.(e);
        registerTab(title, e.nativeEvent.layout.y);
      }}
      {...rest}
    />
  );
};
